import { render } from "./infoDetails.vue?vue&type=template&id=65ab11b8&scoped=true"
import script from "./infoDetails.vue?vue&type=script&lang=js"
export * from "./infoDetails.vue?vue&type=script&lang=js"

import "./infoDetails.vue?vue&type=style&index=0&id=65ab11b8&scoped=true&lang=css"
import "./infoDetails.vue?vue&type=style&index=1&id=65ab11b8&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ab11b8"]])

export default __exports__